import type { PickerDisplayConfig } from '~/scopes/product-core/components/presentationals/CustomizationFunnelCondensed/CustomizationFunnelCondensed.types'
import { getPickerColConfig } from '~/scopes/product-core/components/presentationals/CustomizationFunnelCondensed/composables/usePickerColConfig/utils/getPickerColConfig'

/**
 * Wrapper around {@link getPickerColConfig} to resolve the picker
 * display config for a given product category.
 */
export function usePickerColConfig(categoryId: string) {
  function getPickerDisplay(
    pickerId: string,
    optionsCount?: number,
  ): PickerDisplayConfig {
    return getPickerColConfig(categoryId, pickerId, optionsCount)
  }

  return { getPickerDisplay }
}
